export const useInternalTransferFillOptions = () => {
  function fillOptionsArray<T extends Array<object>>(primary: T, secondary: T) {
    if (secondary?.length > 0) {
      return [
        ...primary,
        {
          value: '__exchange_info__',
          label: '',
          isExchangeInfo: true,
        },
        ...secondary,
      ];
    }

    return [...primary];
  }

  return { fillOptionsArray };
};
